var IDs = {};
export default {
  IDs: IDs,
  getData: function getData(item) {
    return item;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {
    return {
      tags: []
    };
  },
  getBiData: function getLegacySeoBlob() {
    return {
      id: null,
      name: null
    };
  },
  getKeys: function getKeys() {
    return [];
  },
  getSlug: function getSlug() {
    return '';
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(item) {
    return item;
  }
};